import { createContext, useContext } from 'react';

export const ExtensionManager = createContext({
  installed: false,
  status: {},
});

ExtensionManager.displayName = 'ExtensionManager';

export const useExtension = () => {
  const contextValue = useContext(ExtensionManager);
  return contextValue;
};

export const ExtensionManagerProvider = ExtensionManager.Provider;
